import { useNavigate } from "react-router-dom";
import { formatDate } from "../../util";


const PatientBiographicals = ({ patientDetails }) => {

  const navigate = useNavigate();


    if(!patientDetails) return null; // If no patient details, return nothing


    const backToDashboard = () => {
      navigate('/dashboard');
    }
    
    return (

      
        <div className="data-bar">
          <button className="back-button" onClick={backToDashboard}>
            {" "}
            ←{" "}
          </button>
          <div className="details">
            <div className="left-data-item">
              <span className="label"> Forename: </span>
              <span className="value"> {patientDetails.name.forename} </span>
            </div>
            <div className="left-data-item">
              <span className="label"> Surname: </span>
              <span className="value"> {patientDetails.name.surname} </span>
            </div>
          </div>
          <div className="chi-section">
            <span className="label"> CHI Number: </span>
            <span className="value chi-value"> {patientDetails.chId} </span>
          </div>
          <div className="details">
            <div className="right-data-item">
              <span className="label"> DOB: </span>  
              <span className="value">{formatDate(patientDetails.dob)} </span> 
            </div>
            <div className="right-data-item">
              <span className="label"> Age: </span>        
              <span className="value"> {patientDetails.age} </span>
            </div>
            <div className="right-data-item">
              <span className="label"> Sex </span>
              <span className="value"> {patientDetails.sex} </span>
            </div>
          </div>
        </div>
    )


}

export default PatientBiographicals;